import Vue from "vue";
import Vuex from "vuex";

//挂载Vuex
Vue.use(Vuex);

//创建VueX对象
const store = new Vuex.Store({
  state: {
    bserurl: "",
    // 18位身份证正则
    IDCard18: /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    loginState: 0, // 登陆状态
    webTool: "web", // 用户使用的工具
    userInfo: {}, // 用户信息
    examId: "", // 考试ID
    jobId: "", // 报考岗位id
    unitId: "", // 报考单位id
    examInfo: {}, // 考试信息
    applyDetail: {}, // 报考数据
    navList: [], // 侧边栏 流程
    commitedFlag: true, //  是否同意了承诺书
    historyApplyInfo: {}, // 上次提交的信息
    certificateList: [], // 需要上传的证件资料
    nationList: [], //  民族
    politicList: [], //  政治面貌
    marryList: [], //  婚姻状况
    educationList: [], //  最高学历
    degreeList: [], //  最高学位
    areaList: [], //  最高学位
    educationType: [] //  学历类别
  },
  mutations: {
    stateChange(state, val) {
      state = val;
    },
    loginStateChange(state, val) {
      state.loginState = val;
    },
    webToolChange(state, val) {
      state.webTool = val;
    },
    userInfoChange(state, val) {
      state.userInfo = val;
    },
    examIdChange(state, val) {
      state.examId = val;
    },
    jobIdChange(state, val) {
      state.jobId = val;
    },
    unitIdChange(state, val) {
      state.unitId = val;
    },
    navListChange(state, val) {
      state.navList = val;
    },
    commitedFlagChange(state, val) {
      state.commitedFlag = val;
    },
    historyApplyInfoChange(state, val) {
      state.historyApplyInfo = val;
    },
    certificateListChange(state, val) {
      state.certificateList = val;
    },
    examInfoChange(state, val) {
      state.examInfo = val;
    },
    applyDetailChange(state, val) {
      state.applyDetail = val;
    },
    nationListChange(state, val) {
      state.nationList = val;
    },
    politicListChange(state, val) {
      state.politicList = val;
    },
    marryListChange(state, val) {
      state.marryList = val;
    },
    educationListChange(state, val) {
      state.educationList = val;
    },
    degreeListChange(state, val) {
      state.degreeList = val;
    },
    areaListChange(state, val) {
      state.areaList = val;
    },
    educationTypeChange(state, val) {
      state.educationType = val;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js